/* eslint-disable react-hooks/exhaustive-deps */
import { Outlet } from 'react-router-dom';
import { Container } from 'react-bootstrap';

import Layout from 'components/layout/Layout';

const CustomerView = () => {
  return (
      <Layout showRighSideBar={false}>
        <Container className='gne-container'>
          {/* we load the child routes here (customer view list and insights) */}
          <Outlet />
        </Container>
      </Layout>
  );
};

export default CustomerView;
